import React from 'react'
import ReactDOM from 'react-dom/client'
import root from 'react-shadow'
import App from './App.tsx'
import './index.css'

// Create a custom element wrapper for our React app
class CalculatorElement extends HTMLElement {
  constructor() {
    super();
    // Create shadow root
    const shadowRoot = this.attachShadow({ mode: 'open' });
    
    // Create container for React app
    const container = document.createElement('div');
    container.id = 'calculator-root';
    shadowRoot.appendChild(container);

    // Create style element for Tailwind styles
    const styleLink = document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.href = `${window.location.origin}/wp-content/plugins/talentful-calculator/dist/index.css`;
    shadowRoot.appendChild(styleLink);

    // Get hero section attributes
    const heroProps = {
      title: this.getAttribute('data-title') || '',
      description: this.getAttribute('data-description') || '',
      buttonText: this.getAttribute('data-button-text') || '',
      buttonLink: this.getAttribute('data-button-link') || '',
      buttonTarget: this.getAttribute('data-button-target') || '',
    };

    // Mount React app in shadow root
    const reactRoot = ReactDOM.createRoot(container);
    reactRoot.render(
      <React.StrictMode>
        <App heroProps={heroProps} />
      </React.StrictMode>
    );
  }
}

// Register the custom element
customElements.define('talentful-calculator', CalculatorElement);
